import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmService } from './confirm.service';

/**
 * Hôte unique de la boîte de confirmation centralisée. À monter une seule fois
 * dans le layout. Rend `<app-confirm-dialog>` piloté par le `ConfirmService`.
 */
@Component({
    selector: 'app-confirm-host',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ConfirmDialogComponent],
    template: `
        @if (confirm.request(); as req) {
            <app-confirm-dialog
                [cancelLabel]="req.cancelLabel ?? 'Annuler'"
                [confirmIcon]="req.confirmIcon ?? ''"
                [confirmLabel]="req.confirmLabel ?? 'Confirmer'"
                [itemLabel]="req.itemLabel ?? ''"
                [itemType]="req.itemType ?? 'l’élément'"
                [message]="req.message ?? ''"
                [open]="confirm.isOpen()"
                [title]="req.title ?? 'Confirmation requise'"
                [variant]="req.variant ?? 'danger'"
                [warning]="req.warning ?? ''"
                (cancelled)="confirm.dismiss()"
                (confirmed)="confirm.accept()" />
        }
    `,
})
export class ConfirmHostComponent {
    readonly confirm = inject(ConfirmService);
}
